import React from 'react';

/** A still of the product as a care-coordination view: your navigator, your plan, your records. */
const InboxMock: React.FC = () => (
  <div className="inbox" role="img" aria-label="Your Haven Crest care view: a note from your navigator, your care plan, and records arriving">
    <div className="inbox__bar">
      <span className="inbox__dot" /><span className="inbox__dot" /><span className="inbox__dot" />
      <span className="inbox__addr">you@havencresthealth.com</span>
    </div>
    <div className="inbox__body">
      <aside className="inbox__side">
        <div className="plan__title">Your care plan</div>
        <ul className="plan">
          <li className="done">Gather records from 3 offices</li>
          <li className="done">Plain-language summary</li>
          <li className="now">Second-opinion options</li>
          <li>Prep for Oct 2 appointment</li>
          <li>Share records with new doctor</li>
        </ul>
        <span className="btn btn--accent">＋ Request records</span>
      </aside>
      <div className="inbox__list">
        <div className="note">
          <div className="note__who"><span className="note__avatar">J</span><span><strong>Jordan, your navigator</strong><span className="mail__when"> · Today</span></span></div>
          <p>Your Sentara records arrived this morning — 42 pages, mammogram and report. I've written a short summary of what the pathology says and flagged two questions worth asking. I'm also lining up three breast specialists for a second opinion; want me to send your records to any of them?</p>
        </div>
        <div className="mail">
          <span className="mail__ico mail__ico--ok">✓</span>
          <span><span className="mail__from">Records delivered</span> · <span className="mail__subj">Sentara Breast Clinic — 42 pages</span></span>
          <span className="mail__when">Today</span>
        </div>
        <div className="tracker">
          <div className="tracker__title"><span>Request · Duke Health</span><span>Day 6</span></div>
          <div className="tracker__steps">
            <div className="tstep done"><i /> Sent</div>
            <div className="tstep done"><i /> Office received</div>
            <div className="tstep now"><i /> Preparing</div>
            <div className="tstep"><i /> In your inbox</div>
          </div>
        </div>
        <div className="inbox__fee">
          Heads up: Duke charges <strong>$6.50</strong> for paper copies. That fee would be yours. Want me to ask for electronic instead (usually free)? <strong>Yes</strong> · No
        </div>
      </div>
    </div>
  </div>
);

export default InboxMock;
